var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37,2H21c-2.7568359,0-5,2.2431641-5,5v3h2V7c0-1.6542969,1.3457031-3,3-3h16c1.6542969,0,3,1.3457031,3,3v26 c0,1.6542969-1.3457031,3-3,3h-3v2h3c2.7568359,0,5-2.2431641,5-5V7C42,4.2431641,39.7568359,2,37,2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,12H11c-2.7568359,0-5,2.2431641-5,5v24c0,2.7568359,2.2431641,5,5,5h16c2.7568359,0,5-2.2431641,5-5V17 C32,14.2431641,29.7568359,12,27,12z M30,41c0,1.6542969-1.3457031,3-3,3H11c-1.6542969,0-3-1.3457031-3-3V17 c0-1.6542969,1.3457031-3,3-3h16c1.6542969,0,3,1.3457031,3,3V41z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyMedium);
export default __webpack_public_path__ + "static/media/copy--medium.6f80a04310f501ad43aee92621ec90c2.svg";
export { ForwardRef as ReactComponent };